import thumbnail from './linechart_thumb.svg';

export const metadata = {
  name: 'global.section.chartselection.linechart.title',
  id: 'linechart',
  thumbnail,
  icon: 'fa-chart-line',
  categories: ['categories.timeseries', 'categories.correlations'],
  description: 'global.section.chartselection.linechart.description',
  code: '',
  tutorial: '',
};
